export { default } from './ListItemSecondaryAction';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ListItemSecondaryAction/index.js
// module id = 835
// module chunks = 2